import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import Swal from "sweetalert2";
import "./Navbar.css";
import { useAuth } from "../context/AuthContext";

function Navbar() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 80);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleLogout = async () => {
    setMenuOpen(false);
    const result = await Swal.fire({
      title: "Logout",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Logout",
      customClass: {
        popup: "logout-popup",
      },

      background: "transparent",

      backdrop: `
    rgba(0,0,0,0.4)
  `,
    });

    if (result.isConfirmed) {
      logout();
      navigate("/login");
    }
  };

  const navClass = `navbar ${scrolled ? "scrolled navbar-shrunk" : "navbar-transparent"}`;

  return (
    <div ref={navRef}>
      <nav className={navClass}>
        <div className="nav-left">
          <Link to="/" className="logo">
            <img src="/logo.jpeg" alt="Logo" className="logo-img" />
          </Link>
        </div>

        {/* DESKTOP LINKS */}
        <div className="nav-right desktop-only">
          {/* ✅ STEP 4 – About Us */}
          <Link to="/about" style={styles.link}>About Us</Link>

          <Link to="/contact-support" className="nav-link">Contact</Link>

          {user ? (
            <>
              <Link to="/my-bookings" className="nav-link">
                My Bookings
              </Link>

              <Link to="/shop-location" className="location-btn">
                Find Shop
              </Link>

              <Link to="/profile" className="profile-avatar" title="My Profile">
                {user.name?.[0]?.toUpperCase() ?? "U"}
              </Link>

              <button className="logout-btn" onClick={handleLogout}>
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="nav-link">Login</Link>
              <Link to="/signup" className="signup-btn">Sign Up</Link>

              <Link to="/shop-location" className="location-btn">
                Find Shop
              </Link>
            </>
          )}
        </div>

        {/* HAMBURGER */}
        <button
          className={`hamburger mobile-only ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span />
          <span />
          <span />
        </button>
      </nav>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="mobile-menu">
          <Link to="/about" onClick={() => setMenuOpen(false)}>About Us</Link>
          <Link to="/contact-support" onClick={() => setMenuOpen(false)}>Contact</Link>
          {user ? (
            <>
              <Link to="/my-bookings" onClick={() => setMenuOpen(false)}>My Bookings</Link>
              <Link to="/profile" onClick={() => setMenuOpen(false)}>My Profile</Link>
              <Link to="/shop-location" className="location-btn" onClick={() => setMenuOpen(false)}>Find Shop</Link>
              <button className="mobile-logout-btn" onClick={handleLogout}>Logout</button>
            </>
          ) : (
            <>
              <Link to="/login" onClick={() => setMenuOpen(false)}>Login</Link>
              <Link to="/signup" className="mobile-signup" onClick={() => setMenuOpen(false)}>Sign Up</Link>
              <Link to="/shop-location" className="location-btn" onClick={() => setMenuOpen(false)}>Find Shop</Link>
            </>
          )}
        </div>
      )}
    </div>
  );
}

/* ✅ INLINE STYLE USED BY ABOUT US LINK */
const styles = {
  link: {
    textDecoration: "none",
    color: "#fff",
    marginRight: "16px",
    fontWeight: "500",
  },
};

export default Navbar;
